export default {
    'en-gb': {
        more: 'Show more',
        less: 'Show less',
    },
    'de-de': {
        more: 'Mehr anzeigen',
        less: 'Weniger anzeigen',
    },
    'el-gr': {
        more: 'Περισσότερα',
        less: 'Λιγότερα',
    },
    'ja-jp': {
        more: 'もっと見る',
        less: '部分的に表示',
    },
    'ru-ru': {
        more: 'Показать больше',
        less: 'Свернуть',
    },
    'sv-se': {
        more: 'Visa mer',
        less: 'Visa mindre',
    },
    'it-it': {
        more: 'Mostra di più',
        less: 'Mostra di meno',
    },
    'es-es': {
        more: 'Mostrar más',
        less: 'Mostrar menos',
    },
};
